window.addEventListener('DOMContentLoaded', function () {
  const topBtn = document.querySelector('.cta-go-to-top');

  if (topBtn) {
    topBtn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
});
